module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.sameUser) ? _c('modal-confirm', {
    attrs: {
      "body": "Êtes-vous sûr de vouloir désactiver le profil",
      "title": _vm.title,
      "data": _vm.data
    },
    on: {
      "close": _vm.close,
      "confirm": _vm.confirm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sameUser) ? _c('modal-confirm', {
    attrs: {
      "body": "Vous ne pouvez pas désactiver votre propre compte",
      "title": _vm.title,
      "data": _vm.data,
      "only-close": "true"
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10e3ae04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DeactivationModal.vue
// module id = 1801
// module chunks = 2